import React from "react";

const DJPaket = () => {
  return (
    <div>
      <p>
        Här är våra priser. Hör av dig i vårt formulär om du vill ha ett särskilt
        upplägg eller fler detaljer.
      </p>

      <p>
        <strong>DJ Albins rytmer & mixerbord:</strong> 5 000 kr
      </p>

      <p>
        <strong>Tillval</strong>
        <br />
        Högtalarsystem: 2 500 kr
        <br />
        Musikquiz: 1 000 kr
        <br />
        Kärleksråd: 0 kr
      </p>
    </div>
  );
};

export default DJPaket;
